import React, { useCallback } from 'react';
import { Toolbar, SaveButton, Button } from 'react-admin';
import { useForm, useFormState } from 'react-final-form';
import omit from 'lodash/omit';
import withStyles from '@material-ui/core/styles/withStyles';
import DeleteButtonWithConfirm from './DeleteButtonWithConfirm';

const styles = {
  leftButtons: {
    justifyContent: 'flex-start',
    flex: 1,
    display: 'flex'
  },
  saveButton: {
    marginRight: '10px'
  },
  closeButton: {
    border: '1px solid #E0E0E0',
    width: '67px',
    height: '30px',
    borderRadius: '2px',
    backgroundColor: '#FFFFFF',
    marginRight: '10px'
  },
  toolbar: {
    backgroundColor: 'transparent',
    paddingLeft: '16px',
    paddingRight: '16px',
    justifyContent: 'space-between',
    '& button[aria-label="Delete"]': {
      border: '1px solid #f44336',
      height: '30px'
    },
    '& button': {
      '& svg': { display: 'none' }
    },
    '& button[aria-label="Save"]': {
      border: '1px solid #EEEEEE',
      width: '67px',
      height: '30px',
      borderRadius: '2px'
    },
    '& button[aria-label="Cancel"]:disabled': {
      //getting same css rules as the disabled class for the saveButton to be consistent
      backgroundColor: 'rgba(0, 0, 0, 0.12)',
      color: 'rgba(0, 0, 0, 0.26)',
      boxShadow: 'none'
    }
  }
};
const LeftButtons = ({
  classes,
  pristine,
  saving,
  history: { goBack },
  invalid,
  handleSubmitWithRedirect,
  dataTestid,
  ...rest
}) => {
  const form = useForm();
  const { initialValues } = useFormState();

  const formReset = useCallback(() => {
    Object.keys(initialValues).forEach(key => {
      form.change(key, initialValues[key]);
    });
  }, [form, initialValues]);

  return (
    <div className={classes.leftButtons} data-testid={dataTestid}>
      <SaveButton
        redirect={false}
        disabled={pristine}
        aria-label="Save"
        saving={saving}
        invalid={invalid}
        className={classes.saveButton}
        handleSubmitWithRedirect={handleSubmitWithRedirect}
      />
      <Button
        label="Cancel"
        className={classes.closeButton}
        aria-label="Cancel"
        onClick={formReset}
        disabled={pristine}
      />
      <Button label="Back" className={classes.closeButton} onClick={goBack} />
    </div>
  );
};

// forwardInvalid prop allows to get the invalid property forwarded to the save button
const EditToolbar = props => {
  const {
    hasList,
    hasEdit,
    hasShow,
    hasCreate,
    undoable,
    onBeforeDelete,
    deletable = true,
    hasEditPermission,
    hasDeletePermission,
    classes,
    deleteContent,
    ...rest
  } = props;

  return (
    <Toolbar
      {...omit(rest, [
        'showNotification',
        'save',
        'loaded',
        'loading',
        'currentSort',
        'userProfile',
        'dataTestid'
      ])}
      className={classes.toolbar}
    >
      {hasEditPermission && <LeftButtons classes={classes} {...rest} />}
      {deletable && hasDeletePermission && (
        <DeleteButtonWithConfirm
          onBeforeDelete={onBeforeDelete}
          aria-label="Delete"
          deleteContent={deleteContent}
        />
      )}
    </Toolbar>
  );
};

export default withStyles(styles)(EditToolbar);
